import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { delete_batch_loading : true, delete_batch: '', delete_batch_error: false};

export function deleteBatch(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_DELETE_BATCH_ORG:
        return {
            delete_batch_loading: true,
            delete_batch: '',
            delete_batch_error: false
        };
      case organisationConstants.RECIEVE_DELETE_BATCH_ORG:
        return {
            delete_batch_loading: false,
            delete_batch: action.delete_batch,
            delete_batch_error: false
        };
      case organisationConstants.ERROR_DELETE_BATCH_ORG:
        return { 
            delete_batch_loading: false,
            delete_batch: '',
            delete_batch_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/deleteBatchOrg.reducer.js